import Image from 'next/image';

const CircularProgressImage = ({
    src = '/icons/apple-touch-icon.png',
    alt = 'plan',
    progress = 65,
    size = 100,
    strokeWidth = 4,
    strokeColor = '#3b82f6'
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const offset = circumference - (progress / 100) * circumference;

    return (
        <div className='relative inline-block' style={{ width: size, height: size }}>
            <svg className='absolute top-0 left-0 -rotate-90' width={size} height={size}>
                <circle cx={size / 2} cy={size / 2} r={radius} stroke='#e5e7eb' strokeWidth={strokeWidth} fill='none' />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    fill='none'
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap='round'
                    className='transition-all duration-500 ease-out'
                />
            </svg>

            <div
                className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-full'
                style={{
                    width: size - strokeWidth * 4,
                    height: size - strokeWidth * 4
                }}
            >
                <Image
                    src={src}
                    alt={alt}
                    width={size - strokeWidth * 4}
                    height={size - strokeWidth * 4}
                    className='h-full w-full object-cover'
                />
            </div>
        </div>
    );
};

export default CircularProgressImage;
